export const directoryInformation = {
  podDirectoryFullPath: '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip',
  podDirectoryPath: 'scrip',
  podDirectoryTree: undefined,
  podFilePaths: [
    'scrip/coordinator/detail/route.js',
    'scrip/coordinator/detail/template.hbs',
    'scrip/coordinator/index/controller.js',
    'scrip/coordinator/index/route.js',
    'scrip/coordinator/index/template.hbs',
    'scrip/index/route.js',
    'scrip/organization/controller.js',
    'scrip/organization/route.js',
    'scrip/organization/template.hbs',
    'scrip/organization-reports/controller.js',
    'scrip/organization-reports/distribution/controller.js',
    'scrip/organization-reports/distribution/route.js',
    'scrip/organization-reports/distribution/template.hbs',
    'scrip/organization-reports/route.js',
    'scrip/organization-reports/statements/controller.js',
    'scrip/organization-reports/statements/route.js',
    'scrip/organization-reports/statements/template.hbs',
    'scrip/organizations/controller.js',
    'scrip/organizations/route.js',
    'scrip/organizations/template.hbs',
    'scrip/template.hbs',
    'scrip/users/detail/route.js',
    'scrip/users/detail/template.hbs',
    'scrip/users/index/controller.js',
    'scrip/users/index/route.js',
    'scrip/users/index/template.hbs',
  ],
  podFileFullPaths: [
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/coordinator/detail/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/coordinator/detail/template.hbs',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/coordinator/index/controller.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/coordinator/index/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/coordinator/index/template.hbs',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/index/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization/controller.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization/template.hbs',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization-reports/controller.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization-reports/distribution/controller.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization-reports/distribution/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization-reports/distribution/template.hbs',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization-reports/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization-reports/statements/controller.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization-reports/statements/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organization-reports/statements/template.hbs',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organizations/controller.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organizations/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/organizations/template.hbs',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/template.hbs',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/users/detail/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/users/detail/template.hbs',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/users/index/controller.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/users/index/route.js',
    '/Users/ryantablada/sites/prototypal/n2/host-web/app/pods/scrip/users/index/template.hbs',
  ],
};
